export default __webpack_public_path__ + "static/media/27_2_1.e17ce833.png";